import { message } from 'antd';

export const ShowMessage = {
    success(content: any, duration?: number) {
        message.success(content, duration);
    },
    error(content: any, duration?: number) {
        message.error(content, duration);
    },
}
